import React from "react";
import ReferralDisplay from "./ReferralDisplay";
import { Referral, ReferralFormData } from "types";
import ReferralFormFields from "./ReferralFormFields";

interface ReferralFormSectionProps {
  isEditMode: boolean;
  isEditing: boolean;
  isAssetCoordinator: boolean;
  formState: ReferralFormData;
  methods: { uu_id: string; name: string }[];
  onChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => void;
  onSubmit: (e: React.FormEvent) => void;
  onEditClick: () => void;
  onCancelEdit: () => void;
  prohabition_request_registration_number?: string | null;
  action_status: string;
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>;
  uploadedFiles: File[];
  fileRowProps: any;
  asset_recovery_request_registration_number: string | null;
  hasCourtData:boolean|null
  referral?:Referral | null
  hasRecoveryCourtData:boolean
  setIsProsecutorReassignPopupOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsForwardPopupOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsReinitiateRequestPopupOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsSuspensionRequestPopupOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ReferralFormSection: React.FC<ReferralFormSectionProps> = ({
  isEditMode,
  isEditing,
  isAssetCoordinator,
  formState,
  methods,
  onChange,
  onSubmit,
  onEditClick,
  onCancelEdit,
  prohabition_request_registration_number,
  action_status,
  uploadedFiles,
  setUploadedFiles,
  fileRowProps,
  asset_recovery_request_registration_number,
  hasCourtData,referral,hasRecoveryCourtData,setIsProsecutorReassignPopupOpen,setIsForwardPopupOpen,
  setIsReinitiateRequestPopupOpen,setIsSuspensionRequestPopupOpen,
}) => {
  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <form onSubmit={onSubmit}>
        {isEditMode && !isEditing ? (
          <ReferralDisplay
            formState={formState}
            isAssetCoordinator={isAssetCoordinator}
            prohabition_request_registration_number={
              prohabition_request_registration_number
            }
            onEditClick={onEditClick}
            isEditMode={isEditMode}
            isEditing={isEditing}
            asset_recovery_request_registration_number={
              asset_recovery_request_registration_number
            }
            action_status={action_status}
            fileRowProps={fileRowProps}
            hasCourtData={hasCourtData}
            referral={referral}
            hasRecoveryCourtData={hasRecoveryCourtData}
            assignedProsecutor={referral?.assigned_prosecutor || null}
            setIsProsecutorReassignPopupOpen={setIsProsecutorReassignPopupOpen}
          
            reinitiate_request_documents={referral?.reinitiate_request_documents}
          />
        ) : (
          <ReferralFormFields
            formState={formState}
            methods={methods}
            onChange={onChange}
            isEditing={isEditing}
            isEditMode={isEditMode}
            onCancelEdit={onCancelEdit}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
          />
        )}
      </form>
    </div>
  );
};
